import { useMutation, useQueryClient } from "@tanstack/react-query"
import { addDevice, selfRegisterDevice } from "@/data/requests/deviceRequests"

export const useAddDeviceMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: addDevice,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["self"] }),
  })
}

export const useSelfRegisterDeviceMutation = () =>
  useMutation({
    mutationFn: selfRegisterDevice,
  })
